<template>
  <div class="title">
    <div class="left_hr"></div>
    <div class="text">{{ Msg }}</div>
    <div class="right_hr"></div>
  </div>
</template>

<script>
export default {
  props: ["Msg"],
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .text{
      font-size: 16px;
      color: rgba(0,110,251,1);
      font-weight: 600;
      margin: 0 10px;
  }
  .left_hr {
    // width: 70px;
    flex: 1;
    height: 1px;
    border: 1px solid;
    border-image: linear-gradient(
        270deg,
        rgba(200, 200, 200, 1),
        rgba(255, 255, 255, 1)
      )
      1 1;
  }
  .right_hr {
    // width: 75px;
      flex: 1;
    height: 1px;
    border: 1px solid;
    border-image: linear-gradient(
        270deg,
         rgba(255, 255, 255, 1),
        rgba(200, 200, 200, 1)
       
      )
      1 1;
  }
}
</style>